import { withTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { Menu as MenuIcon, Refresh } from '@mui/icons-material'
import {
  AppBar as MuiAppBar,
  Breadcrumbs,
  Grid2 as Grid,
  IconButton as MuiIconButton,
  Toolbar,
  Tooltip,
} from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router-dom'

import { useRefreshContext } from '@/contexts/RefreshContext'
import { usePermissions } from '@/hooks/usePermissions'
import useT from '@/i18n/useT'

import SettingsButton from '../SettingsButton'
import NavbarUserDropdown from './NavbarUserDropdown'

const AppBar = styled(MuiAppBar)`
  background: ${props => props.theme.header.background};
  color: ${props => props.theme.header.color};
`

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`

type NavbarProps = {
  onDrawerToggle: React.MouseEventHandler<HTMLElement>
  breadcrumbs?: React.ReactNode
}

const PATHS_TO_HIDE_REFRESH = ['/admin/profile', '/admin/plan-management']

const Navbar: React.FC<NavbarProps> = ({ onDrawerToggle, breadcrumbs }) => {
  const { roles } = usePermissions()
  const { refresh } = useRefreshContext()
  const location = useLocation()
  const { t } = useT()

  const shouldHideRefreshButton = PATHS_TO_HIDE_REFRESH.some(path =>
    location.pathname.includes(path),
  )

  return (
    <>
      <AppBar
        position="sticky"
        elevation={1}
        sx={{
          width: '100%',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Toolbar sx={{ maxWidth: 1440, width: '100%' }}>
          <Grid
            container
            alignItems="center"
            sx={{
              width: '100%',
            }}
          >
            <Grid sx={{ display: { xs: 'block', md: 'none' } }}>
              <IconButton
                aria-label={t('navbar.menu.openDrawer.aria')}
                onClick={onDrawerToggle}
                size="large"
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid sx={{ display: { xs: 'none', md: 'block' } }}>
              <Breadcrumbs>{breadcrumbs}</Breadcrumbs>
            </Grid>
            <Grid size="grow" />
            <Grid>
              {shouldHideRefreshButton ? null : (
                <IconButton onClick={refresh}>
                  <Tooltip title={t('common.refreshOnPage')}>
                    <Refresh />
                  </Tooltip>
                </IconButton>
              )}
              {/* TODO: need to check for permissions */}
              {roles?.some(name => name === 'Admin' || name === 'Manager') && (
                <SettingsButton />
              )}
              <NavbarUserDropdown />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  )
}

export default withTheme(Navbar)
